export default __webpack_public_path__ + "static/media/client-03.bcdb6166.png";